module.exports = __webpack_public_path__ + "img/108.57324b71.jpg";